import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-story',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './story.component.html',
  styleUrl: './story.component.scss'
})
export class StoryComponent implements OnInit, OnDestroy {
  // Article title and date
  title = 'النقلة في المقبرة';
  titleEn = 'The Transformation of the Cemetery';
  publishDate = new Date();
  language: string = 'ar';

  private destroy$ = new Subject<void>();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    // Initialize with current language
    this.language = this.translateService.currentLang || 'en';

    // Subscribe to language changes
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        this.language = event.lang;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
